import { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingComp from "../../../../components/re-usable/loading/loading";
import useAuth from "../../../../hooks/useAuth";
import TwoColumnLayOut from "../../../../layouts/two-columns/two-column-layout";
import { ArticleDetailsDetails } from "../../../../models/article-detaisls-model";
import { retrieveNewsArticlesRightSideTaxonomy } from "../../../../redux/slice/right-side/new-articles-right-side-taxonomy-slice";
import { retrieveNewsArticlesRightSideBooks } from "../../../../redux/slice/right-side/news-articles-right-side-books-slice";
import { retrieveNewsArticlesRightSideLearning } from "../../../../redux/slice/right-side/news-articles-right-side-learning-slice";
import { cleanNewsArticlesRightSideNews, retrieveNewsArticlesRightSideNews } from "../../../../redux/slice/right-side/news-articles-right-side-news-slice";
import { retrieveNewsArticlesRightSideRelatedEvents } from "../../../../redux/slice/right-side/news-articles-right-side-related-events-slice";
import { RootState, useAppDispatch } from "../../../../redux/store";

const NewsArticlesLayoutComponent = (props: { children: ReactNode }) => {
  const location = useLocation();
  const pathName = location.pathname;
  const user = useAuth().getUser();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { rightSideFeaturedBooksData, Loading: booksLoading } = useSelector((state: RootState) => state.NewsArticlesRightSideBooks);
  const { rightSideFeaturedLearningData, Loading: learningLoading } = useSelector((state: RootState) => state.NewsArticlesRightSideLearning);
  const { rightSideTrendingNewsData, Loading: newsLoading } = useSelector((state: RootState) => state.NewsArticlesRightSideNews);
  const { rightSidePopularEventsData, Loading: eventsLoading } = useSelector((state: RootState) => state.NewsArticlesRightSideRelatedEvents);
  const { data, loading: taxonomyLoading } = useSelector((state: RootState) => state.NewsArticlesRightSideTaxonomy);

  const { ArticleDetailsData } = useSelector((state: RootState) => state.ArticleDetails);

  const [articleDetails, setArticleDetails] = useState<ArticleDetailsDetails | null>(ArticleDetailsData[0]?.articleItems[0] || null);

  useEffect(() => {
    if (location.pathname.toLowerCase() !== window.location.pathname.toLowerCase()) {
      setArticleDetails(null);
    }
  }, [location]);

  useEffect(() => {
    setArticleDetails(ArticleDetailsData[0]?.articleItems[0]);
  }, [ArticleDetailsData]);

  useEffect(() => {
    if (pathName) {
      if (!booksLoading) dispatch(retrieveNewsArticlesRightSideBooks(pathName));
      if (!taxonomyLoading) dispatch(retrieveNewsArticlesRightSideTaxonomy(pathName));
      if (!learningLoading) dispatch(retrieveNewsArticlesRightSideLearning(pathName));
      if (!newsLoading) dispatch(retrieveNewsArticlesRightSideNews(pathName));
      if (!eventsLoading) dispatch(retrieveNewsArticlesRightSideRelatedEvents(pathName));
    }

    return () => {
      dispatch(cleanNewsArticlesRightSideNews());
    }
  }, [dispatch, pathName]);

  let detailPageNewsTrail = {
    trendingNewsData: rightSideTrendingNewsData,
    popularEventsData: rightSidePopularEventsData,
    featuredLearningData: rightSideFeaturedLearningData,
    featuredBooksData: rightSideFeaturedBooksData,
  };

  // Need to change condition to make it follow the React way
  const [scriptHasRan, setScriptHasRan] = useState(false);

  useEffect(() => {
    if (articleDetails !== undefined && articleDetails !== null && !scriptHasRan && window.runGlobalScripts) {
      setScriptHasRan(true);
      window.runGlobalScripts();
    }
  }, [articleDetails])

  if (ArticleDetailsData[0]?.statusCode === 401 && (user === null || user === undefined)) {
    navigate(`/login?returnurl=${pathName.replace(/\//g, "%2F")}`, { state: { from: pathName } });

    return <LoadingComp />;
  }

  if (ArticleDetailsData[0]?.statusCode === 403) {
    navigate(`/prohibited?returnurl=${pathName.replace(/\//g, "%2F")}`, { state: { from: pathName } });

    return <LoadingComp />;
  }

  if (articleDetails === undefined || articleDetails === null) return <LoadingComp />;

  return (
    <>
      <TwoColumnLayOut
        breadcrumbPath={pathName}
        isBreadcrumbpath={false}
        detailPageTaxonomy={data}
        detailPageNewsTrail={detailPageNewsTrail}
        showAds={true}
        showAdsOutside={true}
        isSubscribeButton={true}
        siteTop={
          <div style={{ textAlign: "center" }}>
            <NewsArticlesTopBannerAds />
          </div>
        }
        newsArticleDetailAds={<NewsArticleContentBanners />}
        customUseDfpSlot={<></>}
        isDetails={true}
        addSchema={true} 
        schemaOptions={{ itemType: "https://schema.org/Article" }}
      >
        {props.children}
      </TwoColumnLayOut>
      <div dangerouslySetInnerHTML={{ __html: FigureModal }}></div>
    </>
  );
};

export default NewsArticlesLayoutComponent;

const NewsArticlesTopBannerAds = () => {
  return (
    <>
      <div className="text-center top-banner" id="topbanner">
        <div className="CMSBanner Banner topbanner gadsbanner" id="div-gpt-ad-1611326459208-0" style={{ width: "970px", height: "90px", display: "none", margin: "0 auto" }}></div>
        <div className="CMSBanner Banner topmobile gadsbanner" id="div-gpt-ad-1611693088874-0" style={{ width: "300px", height: "50px", display: "none", margin: "0 auto" }}></div>
      </div>

      <style type="text/css">{`
        @media only screen and (max-width: 1260px) {
          .topmobile, .contentmobile {
            display: block;
          }
          .topbanner, .contentbanner {
            display: none;
          }
        }
        @media only screen and (min-width: 1260px) {
          .topmobile, .contentmobile {
            display: none;
          }
          .topbanner, .contentbanner {
            display: block;
          }
        }
        #topbanner { display: block !important; }
      `}</style>
    </>
  );
};

const NewsArticleContentBanners = () => {
  return (
    <div id="adcontentbannersdiv">
      <div className="adunitcontent1 mt-4 mb-2">
        <NewsArticleContentBannerAds1 />
      </div>
      <div className="adunitcontent2 mt-4 mb-2">
        <NewsArticleContentBannerAds2 />
      </div>
      <div className="adunitcontent3 mt-4 mb-2">
        <NewsArticleContentBannerAds3 />
      </div>
    </div>
  );
};

const NewsArticleContentBannerAds1 = () => {
  return (
    <>
      <div className="text-center CMSBanner Banner contentbanner gadsbanner" id="div-gpt-ad-1649701637206-0" style={{ minWidth: "970px", minHeight: "90px", display: "none" }}></div>
      <div className="text-center CMSBanner Banner contentmobile gadsbanner" id="div-gpt-ad-1649701809430-0" style={{ minWidth: "300px", minHeight: "50px", display: "none" }}></div>
    </>
  );
};

const NewsArticleContentBannerAds2 = () => {
  return (
    <>
      <div className="text-center CMSBanner Banner contentbanner gadsbanner" id="div-gpt-ad-1649701921828-0" style={{ minWidth: "970px", minHeight: "90px", display: "none" }}></div>
      <div className="text-center CMSBanner Banner contentmobile gadsbanner" id="div-gpt-ad-1649701861184-0" style={{ minWidth: "300px", minHeight: "50px", display: "none" }}></div>
    </>
  );
};

const NewsArticleContentBannerAds3 = () => {
  return (
    <>
      <div className="text-center CMSBanner Banner contentbanner gadsbanner" id="div-gpt-ad-1649702008484-0" style={{ minWidth: "970px", minHeight: "90px", display: "none" }}></div>
      <div className="text-center CMSBanner Banner contentmobile gadsbanner" id="div-gpt-ad-1649702035816-0" style={{ minWidth: "300px", minHeight: "50px", display: "none" }}></div>
    </>
  );
};

const FigureModal = `
<div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="figureModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">View Figure <span>&nbsp;</span>
        </h5>
        <div align="center" class="navigation">
          <span class="arrow left">&larr;</span> &nbsp; <span class="arrow right">&rarr;</span>
        </div>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <img id="imgFigure" style="display: block; margin: auto; width: 100%; height: auto;" />
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-dismiss="modal" type="button">Close</button>
      </div>
    </div>
  </div>
</div>
`;